import React from "react"
import Modal, { Action } from "@kit/design/modal"
import { createRoot } from "react-dom/client"

const renderConfirmEmailModal = message => {
  const container = document.createElement("div")
  const root = createRoot(container)

  const close = () => {
    root.unmount()
    container.remove()
  }

  const handleCancel = () => {
    close(false)
  }

  const dialog = (
    <Modal
      onClose={handleCancel}
      label="Confirmation Required"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
    >
      {message}
      <Action variant="secondary" onClick={handleCancel}>
        Cancel
      </Action>
      <Action href="/account_settings/account_info">
        Manage Email Address
      </Action>
    </Modal>
  )

  root.render(dialog)

  document.body.appendChild(container)
}

export const handle = (response, responseJson) => {
  if (response.status === 401) {
    if (responseJson?.error === "email-confirmation") {
      renderConfirmEmailModal(responseJson.message)
      return true
    }
  }

  return false
}
